import axios from 'axios';
//let apiurl = "http://43.204.36.226";
let apiurl ="https://asseshub.com";
// let apiurl ="http://localhost:8080";
// let apiurl ="https://rrryuva.com";
// let apiurl ="https://visualpathjobs.com";
// let apiurl ="https://carrertek.com";
// let apiurl="https://nodejsfullstack.in"

export const Signup = async (fields) => {
    return await axios.post(apiurl + "/api/v1/auth/signup", fields)
        .then((res) => {
            return res.data;
        }).catch((error) => {
            // window.location = "/";
            return error;
        });


}



export const LoginForm = async (fields) => {
    return await axios.post(apiurl + "/api/auth/login", fields)
        .then((res) => {
            return res.data;
        }).catch((error) => {
            // window.location = "/";
            return error;
        });


}


export const ChangeTenantPassword= async (data)=>{
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
     
    }
    return await axios.post(apiurl + "/api/auth/changetenantpassword",data,{'headers':headers})
    .then((res) => {
        console.log("getting data",res.data);
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        // window.location.reload();
        return error;
    });

}


// Tenants

export const GetAllTenants = async (data) => {
   
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
     
    }
    return await axios.post(apiurl + "/api/v1/tenant/get",data,{'headers':headers})

        .then((res) => {
            // console.log("getting data",res.data);
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 

export const SaveTenants = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/tenant/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateTenants = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/tenant/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');

            window.location.reload();
            return error;
        });



} 
export const DeleteTenants = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/tenant/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });
} 

// Area
export const getAllArea = async (data) => {

    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
     
    }
    return await axios.post(apiurl + "/api/v1/areas/get",data,{'headers':headers})
    .then((res) => {

        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        window.location.reload();
        return error;
    });


}
export const saveArea = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }

    return await axios.post(apiurl + "/api/v1/areas/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 
export const updateArea = async (data) => {

    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
  
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,

       
    }
 
    
    return await axios.post(apiurl + "/api/v1/areas/update",data,{'headers':headers})

        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });

    }


//Events

export const GetAllEvents = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));

    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
     
    }
    return await axios.post(apiurl + "/api/v1/events/get",data,{'headers':headers})
    .then((res) => {
        console.log("getting data",res.data);
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        console.log("error in getting data");
        window.location.reload();
        return error;
    });
}


export const SaveEvents = async (ele) => {
    console.log(ele,"check common fields")
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	console.log('called')
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,

    }
        return await axios.post(apiurl + "/api/v1/events/save",ele,{'headers':headers})
        .then((res) => {

            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        })

    }
export const UpdateEvents = async (ele) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,

       
    }
    return await axios.post(apiurl + "/api/v1/events/update",ele,{'headers':headers})
    .then((res) => {
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        window.location.reload();
        return error;
    });

} 

export const deleteEvent = async (ele) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,

       
    }
    return await axios.post(apiurl + "/api/v1/events/delete",ele,{'headers':headers})
    .then((res) => {
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        window.location.reload();
        return error;
    });

} 

//Latest News
export const GetAllLatestNews = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/news/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveLatestNews = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/news/save",data,{'headers':headers})
    .then((res) => {
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        //window.location.reload();
        return error;
    });
}
export const UpdateLatestNews = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
    }
    return await axios.post(apiurl + "/api/v1/news/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 

export const DeleteLatestNews = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
    }
    return await axios.post(apiurl + "/api/v1/news/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 

// SocialLinks

export const GetAllSocialLinks = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
    }
        return await axios.post(apiurl + "/api/v1/sociallink/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });

    }

    export const SaveSocialLinks = async (data) => {
        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        console.log(constuserdetails);
        const headers = {
            'content-type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
            'X-Frame-Options': 'SAMEORIGIN',
            'x-access-token': constuserdetails.accessToken,
        }
            return await axios.post(apiurl + "/api/v1/sociallink/save",data,{'headers':headers})
            .then((res) => {
                return res.data;
            }).catch((error) => {
                localStorage.removeItem('userDetails');
                // window.location.reload();
                return error;
            });
    
        }
    export const UpdateSocialLinks = async (data) => {
        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        
        const headers = {
            'content-type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
            'X-Frame-Options': 'SAMEORIGIN',
            'x-access-token': constuserdetails.accessToken,
        }
            return await axios.post(apiurl + "/api/v1/sociallink/update",data,{'headers':headers})
            .then((res) => {
                return res.data;
            }).catch((error) => {
                localStorage.removeItem('userDetails');
                // window.location.reload();
                return error;
            });
    
        }

        export const DeleteSocialLinks = async (data) => {
            const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
            
            const headers = {
                'content-type': 'application/json',
                'X-Content-Type-Options': 'nosniff',
                'X-Frame-Options': 'SAMEORIGIN',
                'x-access-token': constuserdetails.accessToken,
            }
                return await axios.post(apiurl + "/api/v1/sociallink/delete",data,{'headers':headers})
                .then((res) => {
                    return res.data;
                }).catch((error) => {
                    localStorage.removeItem('userDetails');
                    // window.location.reload();
                    return error;
                });
        
            }
    
// Youtube Video
export const getYoutubeVideo = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
    }
    return await axios.post(apiurl + "/api/v1/videos/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });
} 

export const saveYoutubeVideo = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,

    }
    return await axios.post(apiurl + "/api/v1/videos/save",data,{'headers':headers})
    .then((res) => {
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        window.location.reload();
        return error;
    });
   
}


export const updateYoutubeVideo = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
    }
    return await axios.post(apiurl + "/api/v1/videos/update",data,{'headers':headers})

        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 

export const deleteYoutubeVideo = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
    }
    return await axios.post(apiurl + "/api/v1/videos/delete",data,{'headers':headers})

        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 



//Logo

export const GetAllLogos = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    console.log(headers);
    return await axios.post(apiurl + "/api/v1/logo/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveLogos = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/logo/save",data,{'headers':headers})
    .then((res) => {
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        window.location.reload();
        return error;
    });
    }

export const UpdateLogos = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/logo/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


}

export const deletLogoImages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/logo/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


}

//SliderImages
export const GetAllSliderImages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/sliderimages/get",data,{'headers':headers})
        .then((res) => {
            console.log("getting data",res.data);
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            console.log("error in getting data");
            window.location.reload();
            return error;
        });

} 
export const SaveSliderImages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,}
        return await axios.post(apiurl + "/api/v1/sliderimages/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });

} 
export const UpdateSliderImages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/sliderimages/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


}

export const DeleteSliderImages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/sliderimages/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


}


// banners

export const GetAllBanner = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/banner/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 


export const SaveBanner = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/banner/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateBanner = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/banner/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 
export const DeleteBannerImage = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/banner/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


}

//Branches

export const GetAllBranches = async (data) => {
    
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));

    
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/branches/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveBranches = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/branches/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateBranches = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/branches/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 

//states

export const GetAllStates = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/states/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveStates= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/states/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateStates = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/states/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 

export const GetCategory= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/category/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveCategory= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/category/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateCategory= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/category/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const GetPrograms= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/itprograms/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SavePrograms= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/itprograms/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdatePrograms= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/itprograms/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetProgramcourses= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/programcourses/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveProgramCourses= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/programcourses/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateProgramcourses= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/programcourses/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetSections= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/sections/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveSections= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/sections/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateSections= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/sections/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const DeleteSections= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/sections/delete",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const GetSectionitems= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/sectionitems/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveSectionitems= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/sectionitems/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateSectionitems= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/sectionitems/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const DeleteSectionitems= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/sectionitems/delete",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const GetEducation= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/education/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveEducation= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/education/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateEducation= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/education/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetEducationTypes= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/edutypes/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveEducationtypes= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/edutypes/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateEducationTypes= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/edutypes/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const GetEducationProgram= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/eduprograms/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveEducationProgram= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/eduprograms/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateEducationProgram= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/eduprograms/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetStudentProgram= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/studentcourses/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveStudentProgram= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/studentcourses/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateStudentProgram= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/studentcourses/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}



export const GetAllUniversity = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/university/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveUniversity= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/university/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateUniversity = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/university/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 


export const GetAllSemisters = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/semisters/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveSemisters = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/semisters/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateSemisters = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/semisters/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 


export const GetAllAcademicsTypes = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/academicstypes/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveAcademicsTypes = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/academicstypes/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateAcademicsTypes = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/academicstypes/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 


export const GetAllAcademicContent = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/academics/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveAcademicContent = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/academics/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateAcademicContent = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/academics/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 


//settings


export const GetAllSettings = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/settings/get",data,{'headers':headers})
        .then((res) => {
            {console.log("settings data",res.data)}
            return res.data;
            
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            {console.log("settings data",error)}
            return error;
        });


} 
export const SaveSettings = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/settings/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateSettings = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/settings/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 


export const GetDistricts= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/districts/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveDistricts= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/districts/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateDistricts= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/districts/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const DeleteDistricts= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/districts/delete",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}
export const DeleteSettings = async (data) => {

    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }

    return await axios.post(apiurl + "/api/v1/settings/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 

//Headertypes

export const GetAllHeaderTypes = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/headertypes/get",data,{'headers':headers})
        .then((res) => {
          
            return res.data;
            
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            {console.log("settings data",error)}
            return error;
        });


} 

export const SaveHeaderTypes= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/headertypes/save",data,{'headers':headers})
    .then((res) => {
           
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        // window.location.reload();
        return error;
    });


}
export const GetAllTrainingCourses= async (data) => {

    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/trainingcourses/get",data,{'headers':headers})

        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}




export const SaveTrainingCourses= async (data) => {
    console.log("course data ====> ",data)
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	console.log(constuserdetails,"===> access token")
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/trainingcourses/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const UpdateTrainingCourses= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
    console.log(constuserdetails,"===> access token")
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/trainingcourses/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}
export const DeleteTrainingCourse = async (data) => {
    console.log(data,"deleted data")

    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
    }
        return await axios.post(apiurl + "/api/v1/trainingcourses/delete",data,{'headers':headers})

        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });
       

    }
    export const UpdateHeaderTypes = async (data) => {

        
            console.log("course data ====> ",data)
            const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
            console.log(constuserdetails,"===> access token")
            const headers = {
                'content-type': 'application/json',
                'X-Content-Type-Options': 'nosniff',
                'X-Frame-Options': 'SAMEORIGIN',
                'x-access-token': constuserdetails.accessToken,
                
               
        
            }

    return await axios.post(apiurl + "/api/v1/headertypes/update",data,{'headers':headers})

   

        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });



} 
export const DeleteHeaderTypes = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/headertypes/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 

export const GetAnnouncement = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/common/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveAnnouncement = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/common/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const DeleteAnnouncementImage = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/common/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


}

export const commonGet = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/common/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const commonUpdate = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/common/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetAllUsersData= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/users/get",data,{'headers':headers})
        .then((res) => {
          
            return res.data;
            
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            {console.log("settings data",error)}
            return error;
        });


} 

export const ChangeUserProgram = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/users/changepurchase",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const offlineSubscription = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        'admin-check':'admin'
       
        
       

    }
    return await axios.post(apiurl + "/api/v1/users/subscribe",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const notifymessages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/users/notifymsg",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const genericmessage = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/users/genericmsg",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const genericmessagepushnotification = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/users/genericmsgpushnote",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const generateResume = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        'admin-check':'admin'
        
       

    }
    return await axios.post(apiurl + "/api/v1/users/resume",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetQuestions = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/questions/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveQuestions = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/questions/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const UpdateQuestions = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/questions/update",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const DeleteQuestions = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/questions/delete",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}




export const commonSave = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/common/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}



export const commonDelete = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        'admin-check':'admin'
        
       

    }
    return await axios.post(apiurl + "/api/v1/common/delete",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const Deleteuserfromadmin = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/users/deleteuserfromadmin",data,{'headers':headers})
    .then((res) => {
           
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        // window.location.reload();
        return error;
    });
}

export const deleteAccesstokenData = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        'admin-check':'admin'
        
       

    }
    return await axios.post(apiurl + "/api/v1/users/deleteaccesstoken",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const reactivateAccountData = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/users/reactivate",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const dashboardreport = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/report/dashboardreport",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const studentscousewise = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/report/studentcoursewise",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}



export const assessmentstudentcoursewise = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/report/studentassessment",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const getassessmentreport = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/report/courseenrolledusers",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const getquizresult = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/report/quizresults",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}
export const forgotPasswordAdmin = async (fields) => {
    return await axios.post(apiurl + "/api/v1/auth/forgotpasswordadmin", fields)
        .then((res) => {
            return res.data;
        }).catch((error) => {
            // window.location = "/";
            return error;
        });


}

export const GetAllSubjects = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/subjects/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveSubjects = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/subjects/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}
export const updateSubjects = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/subjects/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 

export const GetAllTopics = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/topic/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveTopics = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/topic/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateTopics = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/topic/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });


} 

export const deleteTopics= async (ele) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,

       
    }
    return await axios.post(apiurl + "/api/v1/topic/delete",ele,{'headers':headers})
    .then((res) => {
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        window.location.reload();
        return error;
    });

} 

export const GetAllSubTopics= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/subtopic/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


} 
export const SaveSubTopics = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/subtopic/save",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateSubTopics = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/subtopic/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            window.location.reload();
            return error;
        });
} 

export const deleteSubTopic= async (ele) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,

       
    }
    return await axios.post(apiurl + "/api/v1/subtopic/delete",ele,{'headers':headers})
    .then((res) => {
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        window.location.reload();
        return error;
    });

} 

export const GetAllSubQuetion= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/subquestions/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveSubQuetion= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/subquestions/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateSubQuetion= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/subquestions/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const deleteSubQuetion= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/subquestions/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });
}

export const GetAllExams = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/exams/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveExams= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/exams/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateExams= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/exams/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const deleteexams= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/exams/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });
}

export const deleteUserCourse= async(data)=>{
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        'admin-check':'admin'
    }
    return await axios.post(apiurl + "/api/v1/users/deleteusercourse",data,{'headers':headers})
    .then((res) => {
       
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        // window.location.reload();
        return error;
    });
}

export const deleteUserCourseItem= async(data)=>{
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        'admin-check':'admin'
    }
    return await axios.post(apiurl + "/api/v1/users/deleteusercourseitem",data,{'headers':headers})
    .then((res) => {
       
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        // window.location.reload();
        return error;
    });
}

export const deleteUserTransactions= async(data)=>{
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        'admin-check':'admin'
    }
    return await axios.post(apiurl + "/api/v1/users/deleteusertransactions",data,{'headers':headers})
    .then((res) => {
       
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        // window.location.reload();
        return error;
    });
}


export const deleteDeviceToken= async(data)=>{
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
    }
    return await axios.post(apiurl + "/api/v1/devicetoken/delete",data,{'headers':headers})
    .then((res) => {
       
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        // window.location.reload();
        return error;
    });
}

export const deleteUserQuiz= async(data)=>{
    // console.log(data,"check data in common services")
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        'admin-check':'admin'
        
        
    }
    return await axios.post(apiurl + "/api/v1/users/deleteuserquiz",data,{'headers':headers})
    .then((res) => {
       
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        // window.location.reload();
        return error;
    });
}

export const deleteUser = async(data)=>{
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        'admin-check':'admin'
    }
    return await axios.post(apiurl + "/api/v1/users/deleteuser",data,{'headers':headers})
    .then((res) => {
       
        return res.data;
    }).catch((error) => {
        localStorage.removeItem('userDetails');
        // window.location.reload();
        return error;
    });
}

export const GetAllExamRules = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/examrules/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveExamRules= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/examrules/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateExamRules= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/examrules/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const deleteExamRules= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/examrules/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });
}

export const generatequestions= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/exams/generatequestions",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });
}



export const GetExamQuestions = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/exams/examquestions",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetAllExamTypes = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/examtype/get",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}
export const saveExamTypes= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/examtype/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateExamTypes= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/examtype/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const deleteExamTypes= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/examtype/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetResumeFormats = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/resumeformat/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveResumeFormat= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/resumeformat/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateResumeFormat= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/resumeformat/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const deleteResumeFormat= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/resumeformat/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetCreateUser = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/createuser/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveCreateUser= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/createuser/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateCreateUser= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/createuser/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const deleteCreateUser= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/createuser/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetToplevelprograms = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/toplevelprogram/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveToplevelprogram= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/toplevelprogram/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateToplevelprogram= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/toplevelprogram/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetInstructors = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/instructor/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const saveInstructor= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/instructor/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateInstructor= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/instructor/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetAllThumbnails = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/thumbnail/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveThumbnail= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/thumbnail/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateThumbnail= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/thumbnail/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const deleteThumbnail= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/thumbnail/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}


export const GetCollegeAdmin = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/collegeadmin/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveCollegeAdmin= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/collegeadmin/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateCollegeAdmin= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/collegeadmin/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const deleteCollegeAdmin= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/collegeadmin/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const clgstudentscousewise = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/report/clgstudentcoursewise",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const clgassessmentstudentcoursewise = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/report/clgstudentassessment",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const SaveCopyQuestions= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/questions/copyquestions",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetAllConstituencydevelopments = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/constituencydevelopments/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveconstituencydevelopments= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/constituencydevelopments/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateconstituencydevelopments= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/constituencydevelopments/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const deleteconstituencydevelopments= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/constituencydevelopments/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetBranchYearPrice = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/branchyearprice/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const savebranchyearprice= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/branchyearprice/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updatebranchyearprice= async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/branchyearprice/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const GetAllDevelopmentImages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
        
       

    }
    return await axios.post(apiurl + "/api/v1/developmentimages/get",data,{'headers':headers})
        .then((res) => {
           
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const saveDevelopmentImages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/developmentimages/save",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const updateDevelopmentImages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/developmentimages/update",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}

export const deleteDevelopmentImages = async (data) => {
    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
	
    const headers = {
        'content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'x-access-token': constuserdetails.accessToken,
       
    }
    return await axios.post(apiurl + "/api/v1/developmentimages/delete",data,{'headers':headers})
        .then((res) => {
            return res.data;
        }).catch((error) => {
            localStorage.removeItem('userDetails');
            // window.location.reload();
            return error;
        });


}